export default {
  iconSizeTiny: '28px',
  iconSizeSmall: '34px',
  iconSizeMedium: '40px',
  iconSizeLarge: '46px',
  iconSizeHuge: '52px'
};